var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShareGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.136378 7.99061C0.129573 9.7002 1.50997 11.0916 3.21959 11.0984C4.00693 11.1015 4.7659 10.8045 5.34198 10.2678L9.95496 12.3506C9.92291 12.5231 9.90534 12.6979 9.90237 12.8733C9.89694 14.5947 11.288 15.9945 13.0093 16C14.7307 16.0054 16.1306 14.6144 16.136 12.893C16.1415 11.1716 14.7504 9.7718 13.0291 9.76633C12.0006 9.76309 11.0368 10.2674 10.453 11.1141L6.11902 9.15718C6.42686 8.41384 6.42805 7.5789 6.12236 6.83469L10.4504 4.86776C11.425 6.27731 13.3577 6.62988 14.7672 5.65529C16.1768 4.68071 16.5293 2.74802 15.5547 1.33848C14.5802 -0.0710733 12.6474 -0.42364 11.2379 0.550943C10.3985 1.13135 9.8981 2.0874 9.89969 3.10796C9.9025 3.28362 9.92032 3.45868 9.95297 3.63131L5.35197 5.72205C4.1054 4.55153 2.14597 4.61317 0.97544 5.85973C0.4337 6.43671 0.133444 7.19918 0.136378 7.99061Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareGrey);
export default __webpack_public_path__ + "static/media/icon-share--grey.cbf4af0f2c1ac5ec182411a9701dbc96.svg";
export { ForwardRef as ReactComponent };